export default __webpack_public_path__ + "static/media/invite-app-bg.cafb79e2.png";